/**
 * Fichier de thème custom
 * @see le fichier par défaut: https://github.com/nathanreyes/v-calendar/blob/next/src/utils/defaults/theme.js
 */
export default {
  /**
   * Définit la couleur du thème
   * v-calendar utilise https://tailwindcss.com/ pour le thème voir leur palette
   * de couleur pour savoir lesquels sont disponibles.
   * La couleur définit ici influe sur le class comme "vc-text-{color}-200" (color est utiliser comme variable)
   * @see liste des couleurs disponible: https://tailwindcss.com/docs/customizing-colors/#default-color-palette
   */
  color: 'blue', // Par défaut on utilise le bleu et on surcharge en CSS
  isDark: false, // Si c'est le mode sombre (Prendra l'option dark dans le theme)
  container: {
    light:
      'vc-text-gray-900 vc-bg-white',
    dark:
      'vc-text-gray-200 vc-bg-gray-900 vc-shadow',
  },
  header: {
    light: 'vc-text-gray-900',
    dark: 'vc-text-gray-200',
  },
  title: {
    light: 'vc-text-lg vc-text-gray-800 vc-font-semibold hover:vc-opacity-75',
    dark: 'vc-text-lg vc-text-gray-100 vc-font-semibold hover:vc-opacity-75',
  },
  arrows: {
    light:
      'vc-border vc-text-gray-600 hover:vc-opacity-50 focus:vc-bg-gray-200',
    dark: 'vc-border vc-text-white hover:vc-opacity-50 focus:vc-bg-gray-800',
  },
  weekdays: {
    light: 'vc-text-sm vc-text-gray-500',
    dark: 'vc-text-sm vc-font-bold vc-text-{color}-200',
  },
  navPopoverContainer: {
    light:
      'vc-rounded-lg vc-text-sm vc-font-semibold vc-text-white vc-bg-gray-800 vc-border vc-border-gray-700 vc-p-1 vc-shadow',
    dark:
      'vc-rounded-lg vc-text-sm vc-font-semibold vc-text-gray-800 vc-bg-white vc-border vc-border-gray-100 vc-p-1 vc-shadow',
  },
  navTitle: {
    light:
      'vc-text-{color}-100 vc-font-bold vc-px-2 vc-py-1 vc-rounded vc-border-2 vc-border-transparent hover:vc-bg-gray-900 focus:vc-border-{color}-600',
    dark:
      'vc-text-gray-900 vc-font-bold vc-px-2 vc-py-1 vc-rounded vc-border-2 vc-border-transparent hover:vc-bg-gray-200 focus:vc-border-{color}-400',
  },
  navArrows: {
    light:
      'vc-rounded vc-border-2 vc-border-transparent hover:vc-bg-gray-900 focus:vc-border-{color}-600',
    dark:
      'vc-rounded vc-border-2 vc-border-transparent hover:vc-bg-gray-200 focus:vc-border-{color}-400',
  },
  navCell: {
    light:
      'vc-w-full vc-font-semibold vc-cursor-pointer vc-text-center vc-py-1 vc-rounded vc-border-2 vc-border-transparent hover:vc-bg-gray-900 hover:vc-shadow-inner hover:vc-text-white focus:vc-border-{color}-600',
    dark:
      'vc-w-full vc-font-semibold vc-cursor-pointer vc-text-center vc-py-1 vc-rounded vc-border-2 vc-border-transparent hover:vc-bg-gray-200 hover:vc-text-gray-900 focus:vc-border-{color}-400',
  },
  navCellInactive: {
    light: 'vc-border-transparent',
    dark: 'vc-border-transparent',
  },
  navCellInactiveCurrent: {
    light: 'vc-text-{color}-100 vc-font-bold vc-border-{color}-100',
    dark: 'vc-text-{color}-600 vc-font-bold vc-border-{color}-500',
  },
  navCellActive: {
    light: 'vc-bg-{color}-100 vc-text-{color}-900 vc-font-bold vc-shadow',
    dark: 'vc-bg-{color}-500 vc-text-white vc-font-bold vc-shadow',
  },
  navCellDisabled: 'vc-opacity-25',
  dayNotInMonth: 'vc-opacity-0 vc-pointer-events-none',
  dayContent: {
    light:
      'vc-border vc-font-medium vc-text-sm vc-cursor-pointer focus:vc-font-bold',
    dark:
      'vc-border vc-font-medium vc-text-sm vc-cursor-pointer focus:vc-font-bold',
  },
  dayContentDisabled: {
    light: 'vc-border vc-text-sm vc-text-gray-400 vc-font-medium vc-pointer-events-none',
    dark: 'vc-border vc-text-sm vc-text-gray-600 vc-font-medium vc-pointer-events-none',
  },
  dayPopoverContainer: {
    light:
      'vc-rounded vc-text-xs vc-text-white vc-font-medium vc-bg-gray-800 vc-border vc-border-gray-700 vc-px-2 vc-py-1 vc-shadow',
    dark:
      'vc-rounded vc-text-xs vc-text-gray-900 vc-font-medium vc-bg-white vc-border vc-border-gray-200 vc-px-2 vc-py-1 vc-shadow',
  },
  dayPopoverHeader: {
    light: 'vc-text-xs vc-text-gray-300 vc-font-semibold',
    dark: 'vc-text-xs vc-text-gray-700 vc-font-semibold',
  },
  highlightBaseFillMode: 'light',
  highlightStartEndFillMode: 'solid',
  highlightStartEndClass: '',
  bgLow: {
    light: 'vc-bg-white bg-colored',
    dark: 'vc-bg-gray-900 vc-border-2 vc-border-{color}-200',
  },
  bgAccentLow: {
    light: 'bg-colored-light',
    dark: 'vc-bg-{color}-800 vc-opacity-75',
  },
  bgAccentHigh: {
    light: 'bg-colored border-colored',
    dark: 'vc-bg-{color}-500',
  },
  contentAccent: {
    light: 'vc-font-bold vc-text-{color}-900',
    dark: 'vc-font-bold vc-text-{color}-100',
  },
  contentAccentContrast: {
    light: 'vc-font-bold vc-text-white',
    dark: 'vc-font-bold vc-text-white',
  },
  datePickerInput:
    'vc-shadow vc-appearance-none vc-border vc-rounded vc-w-full vc-py-2 vc-px-3 vc-text-gray-800 vc-bg-white vc-leading-tight focus:vc-outline-none focus:vc-shadow-outline',
  datePickerInputDrag:
    'vc-shadow vc-appearance-none vc-border vc-rounded vc-w-full vc-py-2 vc-px-3 vc-text-gray-400 vc-bg-white vc-leading-tight focus:vc-outline-none focus:vc-shadow-outline',
};
